import {PeerId, Source} from '../../state/types/common.js';
import {DomainUri} from '../../state/types/domain-registry.js';
import {outgoing} from '../messages.js';
import {Reason} from '../../reason.js';
import {SendMessageAction} from '../../node.js';
import {ContextAdded, ContextCreated, ContextDestroyed, ContextUpdated, SubscribedContext} from './types/messages.js';
import {ContextData, ContextId} from '../../state/types/context.js';
import {ContextDelta} from './types/requests.js';

export function subscribedContext(domainUri: DomainUri, recipient: Source, requestId: string, peerId: PeerId, contextId: ContextId, data?: ContextData): SendMessageAction<'subscribed-context'> {
    const message: SubscribedContext = {
        domain: domainUri,
        type: 'subscribed-context',
        request_id: requestId,
        peer_id: peerId,
        context_id: contextId,
        data
    };
    return outgoing(recipient, message);
}

export function contextAdded(domainUri: DomainUri, recipient: Source, peerId: PeerId, creatorId: PeerId, ctxId, ctxName): SendMessageAction<'context-added'> {
    const message: ContextAdded = {
        domain: domainUri,
        type: 'context-added',
        peer_id: peerId,
        creator_id: creatorId,
        context_id: ctxId,
        name: ctxName
    };
    return outgoing(recipient, message);
}

export function contextDestroyed(domainUri: DomainUri, recipient, peerId: PeerId, ctxId, reason: Reason): SendMessageAction<'context-destroyed'> {
    const message: ContextDestroyed = {
        domain: domainUri,
        type: 'context-destroyed',
        peer_id: peerId,
        context_id: ctxId,
        reason_uri: reason.uri,
        reason: reason.message
    };
    return outgoing(recipient, message);
}

export function contextCreated(domainUri: DomainUri, recipient: Source, requestId: string, peerId: PeerId, contextId: ContextId): SendMessageAction<'context-created'> {
    const message: ContextCreated = {
        domain: domainUri,
        type: 'context-created',
        request_id: requestId,
        peer_id: peerId,
        context_id: contextId
    };
    return outgoing(recipient, message);
}

export function contextUpdated(domainUri: DomainUri, recipient: Source, peerId: PeerId, updaterId: PeerId, contextId: ContextId, delta: ContextDelta): SendMessageAction<'context-updated'> {
    const message: ContextUpdated = {
        domain: domainUri,
        type: 'context-updated',
        peer_id: peerId,
        updater_id: updaterId,
        context_id: contextId,
        delta: delta
    };
    return outgoing(recipient, message);
}
